import React from 'react';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import SettingEditor from './SettingEditor';
import Spacer from '../../../app/common/ui/Spacer';

const SectionSettings = ({ section, settings, onChange }) => {

    return (
        <Paper style={{ padding: '1rem' }}>
            <Typography variant="h6" color="initial">{section}</Typography>
            <Spacer />
            {
                settings?.sort((a, b) => a.field.localeCompare(b.field)).map(item => {
                    return <div key={item.field}>
                        <SettingEditor setting={item} onChange={onChange} />
                        <Spacer />
                    </div>
                })
            }
        </Paper>
    );
};

export default SectionSettings;